// Carrusel de reseñas: arrastrar con el mouse + reproducir videos al clic en play.

class ReviewsCarousel {
  constructor(root) {
    this.root = root;
    this.track = root.querySelector('[data-rcar-track]');
    if (this.track) this.initDrag();
    this.initVideos();
  }

  // --- Arrastrar el carrusel con el mouse (click & drag) ---
  initDrag() {
    let isDown = false;
    let startX = 0;
    let startScroll = 0;
    let moved = false;

    const down = (e) => {
      isDown = true;
      moved = false;
      startX = e.pageX;
      startScroll = this.track.scrollLeft;
      this.track.classList.add('is-dragging');
    };
    const move = (e) => {
      if (!isDown) return;
      const dx = e.pageX - startX;
      if (Math.abs(dx) > 4) moved = true;
      this.track.scrollLeft = startScroll - dx;
    };
    const up = () => {
      isDown = false;
      this.track.classList.remove('is-dragging');
    };

    this.track.addEventListener('mousedown', down);
    this.track.addEventListener('mousemove', move);
    window.addEventListener('mouseup', up);
    this.track.addEventListener('mouseleave', up);

    // Evita que un arrastre dispare clic en los links/botones de las tarjetas
    this.track.addEventListener('click', (e) => {
      if (moved) {
        e.preventDefault();
        e.stopPropagation();
      }
    }, true);
  }

  // --- Reproducir/pausar video al clic en el botón play ---
  initVideos() {
    this.root.querySelectorAll('[data-rcar-video]').forEach((wrap) => {
      const playBtn = wrap.querySelector('[data-rcar-play]');
      const video = wrap.querySelector('video');
      if (!playBtn || !video) return;

      playBtn.addEventListener('click', () => {
        video.muted = false;
        const p = video.play();
        if (p && p.catch) p.catch(() => {});
        wrap.classList.add('is-playing');
      });

      // Al clic sobre el video reproduciéndose, pausar y volver a mostrar el play
      video.addEventListener('click', () => {
        if (!video.paused) {
          video.pause();
          wrap.classList.remove('is-playing');
        }
      });
      video.addEventListener('ended', () => {
        wrap.classList.remove('is-playing');
      });
    });
  }
}

function initReviewsCarousel() {
  document.querySelectorAll('[data-reviews-carousel]').forEach((root) => {
    if (!root.__rcarInit) {
      root.__rcarInit = true;
      new ReviewsCarousel(root);
    }
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initReviewsCarousel);
} else {
  initReviewsCarousel();
}

// Soporte para el editor de temas de Shopify (re-render de secciones)
document.addEventListener('shopify:section:load', initReviewsCarousel);
